// File Metadata:
// Filename: ShipmentMetrics.js
// Version: 1.00
// Created: 2025-03-25 23:38:14
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { Grid, Paper, Typography, Box } from '@mui/material'
import { useGetShipmentlogsQuery } from '../../api/shipmentlogsApiSlice'
import { useMediaQuery, useTheme } from '@mui/material'

const ShipmentMetrics = () => {
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const { data: shipmentlogs } = useGetShipmentlogsQuery('shipmentlogsList')
    
    const metrics = shipmentlogs ? {
        total: Object.keys(shipmentlogs.entities).length,
        pending: Object.values(shipmentlogs.entities)
            .filter(s => s.status === 'PENDING').length,
        inProgress: Object.values(shipmentlogs.entities)
            .filter(s => s.status === 'IN_PROGRESS').length,
        completed: Object.values(shipmentlogs.entities)
            .filter(s => s.status === 'COMPLETED').length,
        urgent: Object.values(shipmentlogs.entities)
            .filter(s => s.priority === 'URGENT').length
    } : {}

    return (
        <Box sx={{ 
            width: '100%',
            height: { xs: 'auto', md: '56px' }, // Match height of form elements
            display: 'flex',
            alignItems: 'center'
        }}>
            <Grid 
                container 
                spacing={1} 
                alignItems="stretch"
            >
                {Object.entries(metrics).map(([key, value]) => (
                    <Grid 
                        item 
                        xs={6} 
                        sm={4} 
                        md={true} 
                        key={key}
                    >
                        <Paper 
                            sx={{ 
                                height: '100%',
                                minHeight: { xs: 'auto', md: '56px' },
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: 1,
                                px: 2
                            }}
                        >
                            <Typography variant="h6" component="span">
                                {value}
                            </Typography>
                            <Typography 
                                variant="body2" 
                                color="text.secondary"
                                component="span"
                                sx={{ whiteSpace: 'nowrap' }}
                            >
                                {key.charAt(0).toUpperCase() + key.slice(1)}
                            </Typography>
                        </Paper>
                    </Grid>
                ))}
            </Grid>
        </Box>
    )
}

export default ShipmentMetrics
